function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */
var React = require("react");

var _require = require("../../icon-paths.js"),
    iconChevronDown = _require.iconChevronDown,
    iconChevronRight = _require.iconChevronRight,
    iconCircleArrowDown = _require.iconCircleArrowDown,
    iconCircleArrowUp = _require.iconCircleArrowUp,
    iconTrash = _require.iconTrash;

var InlineIcon = require("../../components/inline-icon.jsx");

var ElementContainer = function (_React$Component) {
    _inherits(ElementContainer, _React$Component);

    function ElementContainer(props) {
        _classCallCheck(this, ElementContainer);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.toggle = function (e) {
            e.preventDefault();
            _this.setState({ show: !_this.state.show });
        };

        _this.state = {
            show: props.initiallyVisible
        };
        return _this;
    }

    ElementContainer.prototype.render = function render() {
        return React.createElement(
            "div",
            { className: "perseus-interaction-element" },
            React.createElement(
                "a",
                {
                    href: "#",
                    className: "perseus-interaction-element-title " + (this.state.show ? "open" : "closed"),
                    onClick: this.toggle
                },
                this.state.show ? React.createElement(InlineIcon, iconChevronDown) : React.createElement(InlineIcon, iconChevronRight),
                this.props.title
            ),
            React.createElement(
                "div",
                {
                    className: "perseus-interaction-element-content " + (this.state.show ? "enter" : "leave")
                },
                this.props.children,
                (this.props.onUp != null || this.props.onDown != null || this.props.onDelete != null) && React.createElement(
                    "div",
                    { className: "edit-controls" },
                    this.props.onUp != null && React.createElement(
                        "button",
                        { onClick: this.props.onUp },
                        React.createElement(InlineIcon, iconCircleArrowUp)
                    ),
                    this.props.onDown != null && React.createElement(
                        "button",
                        { onClick: this.props.onDown },
                        React.createElement(InlineIcon, iconCircleArrowDown)
                    ),
                    this.props.onDelete != null && React.createElement(
                        "button",
                        { onClick: this.props.onDelete },
                        React.createElement(InlineIcon, iconTrash)
                    )
                )
            )
        );
    };

    return ElementContainer;
}(React.Component);

ElementContainer.defaultProps = {
    initiallyVisible: false,
    title: "More"
};
ElementContainer.propTypes = {
    children: require("react").PropTypes.oneOfType([require("react").PropTypes.any, require("react").PropTypes.node]).isRequired,
    initiallyVisible: require("react").PropTypes.bool.isRequired,
    onDelete: require("react").PropTypes.func,
    onDown: require("react").PropTypes.func,
    onUp: require("react").PropTypes.func,
    title: require("react").PropTypes.oneOfType([require("react").PropTypes.string, require("react").PropTypes.any]).isRequired
};


module.exports = ElementContainer;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/interaction/element-container.jsx
 ** module id = 293
 ** module chunks = 0 1
 **/